<script>
import { onMounted } from "vue";
import { useRouter } from "vue-router";
import authService from "../services/auth.service.js";

export default {
  name: "OidcAuth",
  setup() {
    const router = useRouter();

    onMounted(async () => {
      await authService.logout(true);
      router.push("/login");
    });

    return {
      router
    };
  }
};
</script>
